<template>
  <div id="commentItemComp">
    <van-image
      class="avatar"
      :src="detail.avatar"
      fit="cover"
      round
    ></van-image>
    <div class="content">
      <div class="info">
        <div class="name text-ellipsis">{{detail.nickname||detail.username}}</div>
        <div class="date">{{detail.createTime | formatDate('yyyy年MM月dd日')}}</div>
      </div>
      <div class="textarea">{{detail.content}}</div>
      <div class="icons">
        <div
          class="icons-item"
          :class="{active: detail.isLike}"
          @click.stop.prevent="onOperate('onPraise', detail)">
          <i class="icon icon-zan"></i>
          <span>{{detail.likes}}</span>
        </div>
        <div class="icons-item" @click.stop.prevent="onOperate('onComment', {detail: detail,parentDetail: detail})">
          <i class="icon icon-comment"></i>
          <span>{{detail.reply}}</span>
        </div>
      </div>
      <div class="children" v-if="details.length">
        <div class="item" v-for="item1 in details" :key="item1.id">
          <van-image
            class="avatar"
            :src="item1.avatar"
            fit="cover"
            round
          ></van-image>
          <div class="content">
            <div class="info">
              <div class="name text-ellipsis">{{item1.nickname||item1.name||item1.username}}</div>
              <div class="date">{{item1.createTime | formatDate('yyyy年MM月dd日')}}</div>
            </div>
            <div class="textarea">
              <!--<span>回复</span>-->
              <span class="user">
                <!--{{item1.commentedUser || ''}}-->
                回复：
              </span>
              <span>{{item1.content}}</span>
            </div>
            <div class="icons">
              <div
                class="icons-item"
                :class="{active: item1.isLike}"
                @click.stop.prevent="onOperate('onPraise', item1)">
                <i class="icon icon-zan"></i>
                <span>{{item1.likes}}</span>
              </div>
              <!--<div class="icons-item" @click.stop.prevent="onOperate('onComment', {detail: item1,parentDetail: detail})">-->
                <!--<i class="icon icon-comment"></i>-->
                <!--<span>{{item1.reply}}</span>-->
              <!--</div>-->
            </div>
          </div>
        </div>
        <div v-if="detail.details.length > 2" class="item more" @click="isMore = !isMore">{{isMore ? '收起' : '查看更多'}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommentItemComp',
  props: {
    detail: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  computed: {
    details () {
      const { detail: { details = [] }, isMore } = this;
      return isMore ? details : details.slice(0, 2);
    }
  },
  data () {
    return {
      isMore: false
    };
  },
  methods: {
    onPraise (params) {
      let { $utils, $http } = this;
      !params.isLike && $http.post('community/circle/comment/like', { id: params.id }).then((res) => {
        $utils.successToast(res.msg);
        params.isLike = true;
        params.likes++;
      });
    },
    onOperate (name, params) {
      if (this.$goToLogin()) {
        switch (name) {
          case 'onPraise':
            this.onPraise(params);
            break;
          case 'onComment':
            this.$emit('onComment', params);
            break;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
#commentItemComp {
  padding: 40px 28px;
  display: flex;
  background-color: #fff;
  .avatar {
    width: 60px;
    height: 60px;
    margin-right: 20px;
    flex-shrink: 0;
  }
  .content {
    flex:1;
    position: relative;
    .info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .name {
        flex: 1;
        width: 0;
        font-size: 28px;
        color: #333333;
      }
      .date {
        font-size: 24px;
        color: #999AAA;
      }
    }
    .textarea {
      margin-top: 30px;
      font-size: 28px;
      color: #333444;
    }
    .icons {
      margin-top: 20px;
      display: flex;
      align-items: center;
      .icons-item {
        font-size: 24px;
        color: #999AAA;
        display: flex;
        align-items: center;
        margin-right: 48px;
        .icon {
          width: 32px;
          height: 32px;
          margin-right: 8px;
          &.icon-zan{
            background-image: url("~@/assets/images/issue/icon_zan_01.png");
          }
          &.icon-comment{
            background-image: url("~@/assets/images/issue/icon_comment_01.png");
          }
        }
        &.active {
          color: #F6BE64;
          .icon {
            &.icon-zan {
              background-image: url("~@/assets/images/issue/icon_zan_02.png");
            }
          }
        }
      }
    }
    .children {
      padding: 0 30px;
      background: #F8F8FA;
      border-radius: 10px;
      margin-top: 30px;
      .item {
        display: flex;
        padding: 40px 0;
        &:not(:last-child) {
          border-bottom: 2px solid #eee;
        }
        .content {
          &:after{
            display: none;
          }
          .textarea {
            margin-top: 10px;
            .user {
              /*margin: 0 12px;*/
              color: #999AAA;
            }
          }
        }
      }
      .more {
        align-items: center;
        justify-content: center;
        font-size: 28px;
        color: #5D2BB8;
      }
    }
    &:after{
      content: '';
      width: 100%;
      height: 2px;
      position: absolute;
      background-color: #F0F0F0;
      bottom: -40px;
      left: 0;
    }
  }

}
</style>